<template>
    <div class="profile-labs" v-if="!renderless">
        <div class="row">
            <div class="col-12" v-if="userLabs.length">
                <div class="profile-labs__create">
                    <a href="/personal/lab/">+ Создать лабораторию</a>
                </div>
            </div>

            <div class="col-12">
                <template v-if="!userLabs.length">
                    <no-lab-banner></no-lab-banner>
                </template>
                <template v-else>
                    <div class="row profile-labs__list">
                        <div v-for="lab in userLabs" :key="lab.ID" class="col-sm-6">
                            <lab-card
                                :lab="lab"
                                :equipments="getEquipments(lab.UF_COOKING_TYPE.ID)"
                                :for-who="getForWho(lab.UF_FOR.ID)"
                            >
                                <template #edit-button>
                                    <a class="lab-card__edit" :href="`/personal/lab/${lab.ID}/`">
                                        <span class="d-none d-sm-block">Редактировать</span>
                                        <svg class="d-block d-sm-none">
                                            <use xlink:href="/sprite.svg#icon-edit"></use>
                                        </svg>
                                    </a>
                                </template>
                            </lab-card>
                        </div>
                    </div>
                </template>

                <div class="profile-labs__labs-text" v-if="!isCatalog">
                    <slot></slot>
                </div>
            </div>
        </div>
    </div>

    <div v-else>
        <slot v-bind="{
            labPlaceTypes,
            labCookingTypes,
            userLabs,
            getForWho,
            getEquipments,
        }" />
    </div>
</template>

<script>

/**
 * Корневой элемент
 *
 * Если лабораторий нет, то показываем баннер с кнопкой добавления лаборатории,
 * по клику на которую происходит перенаправление на страницу открытия формы добавления
 *
 * Если лаборатории есть у пользователя, то показывается список лабораторий
 * По клику на кнопку "Редактирование" открывается форма редактирования текущей лаборатории
 */

import NoLabBanner from './no-lab-banner';

export default {
    name: 'labs-list',

    components: { NoLabBanner },

    data() {
        return {
            selectedLab: null,

            modalTitle: null,
            modalComponent: null,
            modalParams: null,

            isCatalog: false,
        };
    },

    props: {
        /**
         * Объект с данными для Выбора типа лаборатории (радио кнопки)
         * В computed есть вариант, преобразованный в массив
         * Если на беке нет данных - передается пустой массив.
         */
        forWhoTypes: {
            type: [Object, Array],
        },

        /**
         * Объект с данными для Выбора названия лаборатории (выпадашка)
         * В computed есть вариант, преобразованный в массив
         * Если на беке нет данных - передается пустой массив.
         */
        cookingTypes: {
            type: [Object, Array],
        },

        /**
         * Oбъект существующих лабораторий у пользователя
         * В computed есть вариант, преобразованный в массив
         * Если на беке нет данных - передается пустой массив.
         */
        labs: {
            type: [Object, Array],
        },

        renderless: {
            type: Boolean,
        },
    },

    computed: {
        labPlaceTypes() {
            return this.forWhoTypes;
        },

        labCookingTypes() {
            return this.cookingTypes;
        },

        userLabs() {
            return this.labs.slice().sort(({ UF_IS_MAIN }) => (UF_IS_MAIN ? -1 : 1));
        },
    },

    methods: {
        prepareArray(propObject) {
            if (propObject) {
                return Object.values(propObject);
            }

            return [];
        },

        getEquipments(id) {
            return this.cookingTypes.find((item) => +item.ID === +id);
        },

        getForWho(id) {
            return this.forWhoTypes.find((item) => +item.ID === +id);
        },
    },
};
</script>
